/* NPTC Card — handler globale per product card premium GoEstasy.
   Estratto da sections/collection-premium-grid.liquid (script inline).
   Funziona ovunque ci sia un .nptc-card nel DOM: collection, home carousel,
   related su PDP, search, ecc. Caricato una volta da theme.liquid.

   Responsabilità:
   - swatch click → updateCard (img, link, prezzo, swatch attivo)
   - quick-add form submit → fetch /cart/add.js + open mini-cart
   - Judge.me reviews source → sync stelle + summary "X.X (N)"
   - reviews button click → modal con widget Judge.me
*/

(function () {
  'use strict';

  /* ============================================================
     SWATCH + UPDATE CARD
  ============================================================ */

  function readVariants(card) {
    const json = card.querySelector('.nptc-variants-json');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return [];
    }
  }

  function getCurrentSelection(card) {
    const selected = {};
    card.querySelectorAll('.nptc-color.is-active[data-option-position], .nptc-size.is-active[data-option-position]').forEach(function (button) {
      selected[button.dataset.optionPosition] = button.dataset.optionValue;
    });
    return selected;
  }

  function findBestVariant(variants, selected) {
    if (!variants.length) return null;

    const selectedKeys = Object.keys(selected);
    const exactAvailable = variants.find(function (variant) {
      return variant.available && selectedKeys.every(function (position) {
        return variant['option' + position] === selected[position];
      });
    });
    if (exactAvailable) return exactAvailable;

    const exactAny = variants.find(function (variant) {
      return selectedKeys.every(function (position) {
        return variant['option' + position] === selected[position];
      });
    });
    if (exactAny) return exactAny;

    return variants.find(function (variant) { return variant.available; }) || variants[0];
  }

  function updateCard(card, variant) {
    if (!variant) return;

    const variantInput = card.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variant.id;

    if (variant.url) {
      card.querySelectorAll('.nptc-card__media, .nptc-card__title, .nptc-card__cta').forEach(function (link) {
        link.setAttribute('href', variant.url);
      });

      const cartLink = card.querySelector('.nptc-card__cart.is-link');
      if (cartLink) cartLink.setAttribute('href', variant.url);
    }

    if (variant.image) {
      const primaryImage = card.querySelector('.nptc-card__image--primary');
      const secondaryImage = card.querySelector('.nptc-card__image--secondary');

      if (primaryImage) {
        primaryImage.src = variant.image;
        primaryImage.removeAttribute('srcset');
        primaryImage.removeAttribute('sizes');
        if (variant.alt) primaryImage.alt = variant.alt;
      }

      if (secondaryImage) secondaryImage.style.opacity = '0';

      card.classList.add('is-variant-selected');
    }

    /* Update prezzo + compare_at_price (fix P0 #9) */
    const priceWrap = card.querySelector('.nptc-card__price');
    if (priceWrap && variant.price) {
      let priceHTML = '<span>' + variant.price + '</span>';
      if (variant.compare_at_price) {
        priceHTML += '<s>' + variant.compare_at_price + '</s>';
      }
      priceWrap.innerHTML = priceHTML;
    }

    card.querySelectorAll('.nptc-color[data-option-position], .nptc-size[data-option-position]').forEach(function (button) {
      const pos = button.dataset.optionPosition;
      const value = button.dataset.optionValue;
      if (variant['option' + pos] === value) {
        button.classList.add('is-active');
      } else {
        button.classList.remove('is-active');
      }
    });
  }

  function initializeCard(card) {
    if (card.dataset.nptcInitialized === 'true') return;
    card.dataset.nptcInitialized = 'true';

    const variants = readVariants(card);
    const variantInput = card.querySelector('input[name="id"]');
    const currentId = variantInput ? String(variantInput.value) : null;
    const currentVariant = variants.find(function (variant) {
      return String(variant.id) === currentId;
    }) || variants.find(function (variant) {
      return variant.available;
    });

    if (currentVariant) updateCard(card, currentVariant);
  }

  function initializeAllCards(scope) {
    scope = scope || document;
    scope.querySelectorAll('.nptc-card').forEach(initializeCard);
  }

  /* Click globale per swatch */
  document.addEventListener('click', function (event) {
    const selector = event.target.closest('.nptc-color[data-option-position], .nptc-size[data-option-position]');
    if (!selector || selector.disabled) return;

    const card = selector.closest('.nptc-card');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    const variants = readVariants(card);
    if (!variants.length) return;

    const position = selector.dataset.optionPosition;
    const value = selector.dataset.optionValue;
    const selected = getCurrentSelection(card);
    selected[position] = value;

    const variant = findBestVariant(variants, selected);
    updateCard(card, variant);
  }, true);


  /* ============================================================
     QUICK-ADD FORM (cart-icon submit)
  ============================================================ */

  function showQuickAddModal(message, isError) {
    if (window.NPTCartModal && typeof window.NPTCartModal.show === 'function') {
      window.NPTCartModal.show(message, { error: Boolean(isError) });
    }
  }

  function normalizeQuickAddError(error) {
    const rawMessage = error && (error.description || error.message || error.status)
      ? String(error.description || error.message || error.status)
      : '';
    const lowerMessage = rawMessage.toLowerCase();

    if (
      lowerMessage.includes('available') ||
      lowerMessage.includes('inventory') ||
      lowerMessage.includes('quantity') ||
      lowerMessage.includes('maximum') ||
      lowerMessage.includes('not enough') ||
      lowerMessage.includes('sold out') ||
      lowerMessage.includes('non disponibile')
    ) {
      return 'Quantità massima già raggiunta.';
    }

    return rawMessage || 'Non riesco ad aggiungere il prodotto al carrello.';
  }

  function refreshCartAfterQuickAdd(cart) {
    if (!cart) return Promise.resolve();

    const cartItems = document.querySelector('cart-items');

    function updateCartCounters() {
      document.querySelectorAll('#cart-icon-bubble .header-cart-count').forEach(function (holder) {
        let qty = holder.querySelector('.minicart-qty');
        if (!qty && cart.item_count > 0) {
          qty = document.createElement('span');
          qty.className = 'minicart-qty';
          holder.appendChild(qty);
        }
        if (qty) {
          qty.textContent = cart.item_count || 0;
          qty.classList.toggle('hidden', !cart.item_count);
        }
      });

      document.querySelectorAll('[data-header-cart-count], [data-cart-count], .cart-count, .minicart-count').forEach(function (counter) {
        if (counter.querySelector && counter.querySelector('svg')) return;
        counter.textContent = cart.item_count || 0;
        counter.classList.toggle('hidden', !cart.item_count);
      });
    }

    function syncCartState(parsedState) {
      try {
        localStorage.setItem('cartJs', JSON.stringify(cart));
        localStorage.setItem('parsedState', JSON.stringify(parsedState || cart));
      } catch (error) {}

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    function resetMiniCartPopups() {
      document.querySelectorAll('mini-cart-popup').forEach(function (cartPopup) {
        if (Array.isArray(cartPopup.cachedResults)) cartPopup.cachedResults = [];
        if (typeof cartPopup.reInit === 'function') cartPopup.reInit();
      });
    }

    function refreshHeaderCartSection() {
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      const sectionUrl = rootUrl + (rootUrl.indexOf('?') === -1 ? '?section_id=header-cart' : '&section_id=header-cart');

      return fetch(sectionUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const freshBubble = doc.querySelector('#cart-icon-bubble');
          const freshPopup = doc.querySelector('#dropdnMinicartPopup');

          if (freshBubble) {
            document.querySelectorAll('#cart-icon-bubble').forEach(function (bubble) {
              bubble.innerHTML = freshBubble.innerHTML;
            });
          } else {
            updateCartCounters();
          }

          if (freshPopup) {
            const popup = document.querySelector('#dropdnMinicartPopup');
            if (popup) {
              popup.innerHTML = freshPopup.innerHTML;
              popup.className = freshPopup.className;
            }
          }

          resetMiniCartPopups();
          syncCartState(cart);
        });
    }

    updateCartCounters();

    if (
      cartItems &&
      typeof cartItems.getSectionsRendered === 'function' &&
      typeof cartItems.renderContents === 'function'
    ) {
      return cartItems.getSectionsRendered()
        .then(function (sectionState) {
          if (!sectionState || !sectionState.sections) throw new Error('Cart sections unavailable');

          const parsedState = Object.assign({}, cart, sectionState, { item_count: cart.item_count });
          cartItems.renderContents(parsedState);
          if (typeof cartItems.toggleEmptyClass === 'function') cartItems.toggleEmptyClass(parsedState);
          if (typeof cartItems.setParsedState === 'function') cartItems.setParsedState(parsedState);
          resetMiniCartPopups();
          syncCartState(parsedState);
        })
        .catch(function () {
          return refreshHeaderCartSection();
        });
    }

    return refreshHeaderCartSection()
      .catch(function () {
        syncCartState(cart);
      });
  }

  function handleQuickAddForm(form, event) {
    const card = form ? form.closest('.nptc-card') : null;
    if (!form || !card) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    const button = form.querySelector('.nptc-card__cart');
    const idInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    let variantId = idInput ? idInput.value : '';
    const quantity = quantityInput ? quantityInput.value || 1 : 1;

    if (!variantId) {
      const variant = findBestVariant(readVariants(card), getCurrentSelection(card));
      if (variant && variant.available) {
        variantId = variant.id;
        if (idInput) idInput.value = variant.id;
      }
    }

    if (!variantId || form.classList.contains('is-loading')) return;

    form.classList.add('is-loading');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
    const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js';

    fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: Number(quantity || 1) }]
      })
    })
      .then(function (response) {
        return Promise.resolve(response.text()).then(function (text) {
          let data = {};
          try { data = text ? JSON.parse(text) : {}; }
          catch (error) { data = { description: text || 'Errore carrello' }; }

          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return fetch(cartUrl, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        return refreshCartAfterQuickAdd(cart)
          .then(function () {
            showQuickAddModal('Aggiunto al carrello.', false);
          });
      })
      .catch(function (error) {
        showQuickAddModal(normalizeQuickAddError(error), true);
      })
      .finally(function () {
        form.classList.remove('is-loading');
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.nptc-card__cart');
    if (!button || button.classList.contains('is-link')) return;

    const form = button.closest('.nptc-card__cart-form');
    if (!form) return;

    handleQuickAddForm(form, event);
  }, true);

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.nptc-card__cart-form');
    if (!form) return;

    handleQuickAddForm(form, event);
  }, true);


  /* ============================================================
     JUDGE.ME REVIEWS SYNC (stelle + summary)
  ============================================================ */

  function refreshJudgeMe() {
    if (window.jdgm) {
      if (typeof window.jdgm.refreshWidgets === 'function') window.jdgm.refreshWidgets();
      if (typeof window.jdgm.refreshBadges === 'function') window.jdgm.refreshBadges();
    }
  }

  function normalizeAverage(value) {
    value = String(value || '').replace(',', '.');
    const match = value.match(/\d+(?:\.\d+)?/);
    if (!match) return '';

    const number = parseFloat(match[0]);
    if (isNaN(number) || number <= 0) return '';

    return number.toFixed(1).replace('.', ',');
  }

  function normalizeCount(value) {
    const match = String(value || '').match(/\d+/);
    if (!match) return '';

    const number = parseInt(match[0], 10);
    return !isNaN(number) && number > 0 ? String(number) : '';
  }

  function updateReviewSummaries(scope) {
    scope = scope || document;

    scope.querySelectorAll('[data-nptc-card-reviews]').forEach(function (wrap) {
      const source = wrap.querySelector('[data-nptc-reviews-source]');
      const starsTarget = wrap.querySelector('[data-nptc-reviews-stars]');
      const summary = wrap.querySelector('[data-nptc-reviews-summary]');
      if (!summary) return;

      const badge = source ? source.querySelector('.jdgm-prev-badge') : null;

      if (starsTarget && source) {
        const stars = source.querySelectorAll('.jdgm-star');
        if (stars.length) {
          starsTarget.innerHTML = '';
          stars.forEach(function (star) {
            const clone = star.cloneNode(true);
            clone.removeAttribute('aria-label');
            clone.setAttribute('aria-hidden', 'true');
            starsTarget.appendChild(clone);
          });
        }
      }

      let average = normalizeAverage(wrap.dataset.ratingAverage);
      let count = normalizeCount(wrap.dataset.ratingCount);

      if (!average && badge) {
        average = normalizeAverage(
          badge.getAttribute('data-average-rating') ||
          badge.dataset.averageRating ||
          badge.getAttribute('data-average') ||
          ''
        );
      }

      if (!count && badge) {
        count = normalizeCount(
          badge.getAttribute('data-number-of-reviews') ||
          badge.dataset.numberOfReviews ||
          (badge.querySelector('.jdgm-prev-badge__text') ? badge.querySelector('.jdgm-prev-badge__text').textContent : '')
        );
      }

            if (average && count) {
        summary.textContent = average + ' (' + count + ')';
      } else if (average) {
        summary.textContent = average;
      } else if (count) {
        summary.textContent = '(' + count + ')';
      }
    });
  }

  function bootReviews() {
    refreshJudgeMe();
    updateReviewSummaries(document);
    setTimeout(function () { updateReviewSummaries(document); }, 600);
    setTimeout(function () { updateReviewSummaries(document); }, 1200);
    setTimeout(function () { updateReviewSummaries(document); }, 2500);
  }


  /* ============================================================
     REVIEWS MODAL (apertura widget Judge.me on demand)
  ============================================================ */

  function ensureReviewsModal() {
    return document.querySelector('[data-nptc-reviews-modal]');
  }

  function closeReviewsModal() {
    const modal = ensureReviewsModal();
    if (!modal) return;
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nptc-reviews-modal-open');
  }

  function openReviewsModal(button) {
    const modal = ensureReviewsModal();
    if (!modal || !button) return;

    const title = modal.querySelector('[data-nptc-reviews-modal-title]');
    const body = modal.querySelector('[data-nptc-reviews-modal-body]');
    const dialog = modal.querySelector('.nptc-reviews-modal__dialog');
    const productTitle = button.dataset.productTitle || 'Prodotto';
    const productUrl = button.dataset.productUrl || '';

    if (title) title.textContent = 'Recensioni · ' + productTitle;
    if (body) body.innerHTML = '<p class="nptc-reviews-modal__loading">Caricamento recensioni…</p>';

    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nptc-reviews-modal-open');
    if (dialog) dialog.focus({ preventScroll: true });

    if (!productUrl || !body) return;

    fetch(productUrl, { credentials: 'same-origin' })
      .then(function (response) { return Promise.resolve(response.text()); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const reviews =
          doc.querySelector('.npt-premium__reviews .jdgm-review-widget') ||
          doc.querySelector('.jdgm-review-widget') ||
          doc.querySelector('#judgeme_product_reviews') ||
          doc.querySelector('.jdgm-widget.jdgm-review-widget');

        if (reviews) {
          body.innerHTML = '';
          body.appendChild(reviews.cloneNode(true));
          refreshJudgeMe();
        } else {
          body.innerHTML = '<p class="nptc-reviews-modal__error">Non riesco a caricare le recensioni per questo prodotto. Apri la pagina prodotto per visualizzarle.</p>';
        }
      })
      .catch(function () {
        body.innerHTML = '<p class="nptc-reviews-modal__error">Non riesco a caricare le recensioni in questo momento.</p>';
      });
  }


  /* ============================================================
     BOOT + GLOBAL OBSERVERS
  ============================================================ */

  function boot() {
    initializeAllCards(document);
    bootReviews();
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  /* Re-init quando vengono aggiunti card via AJAX (infinite scroll, ecc.) */
  const observer = new MutationObserver(function (mutations) {
    let shouldRefresh = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && (node.matches('.nptc-card') || node.matches('[data-nptc-card-reviews]'))) {
          shouldRefresh = true;
        }
        if (node.querySelector && node.querySelector('.nptc-card')) {
          shouldRefresh = true;
        }
      });
    });

    if (shouldRefresh) {
      initializeAllCards(document);
      refreshJudgeMe();
      setTimeout(function () { updateReviewSummaries(document); }, 100);
      setTimeout(function () { updateReviewSummaries(document); }, 900);
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  /* Reviews modal click handlers (delegati al document) */
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-nptc-card-reviews]');
    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      openReviewsModal(openButton);
      return;
    }

    if (event.target.closest('[data-nptc-reviews-modal-close]')) {
      event.preventDefault();
      closeReviewsModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeReviewsModal();
  });

})();
